'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'balloons';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = 'M201.3 339.3c-8.2 7.4-16.7 14.1-25.4 20.7L144 360c-8.7-6.6-17.1-13.3-25.4-20.7-11.6-10.4-27-25.4-42.4-43.6-31.3-37.1-60.2-85.4-60.2-135.7 0-79.5 64.5-144 144-144S304 80.5 304 160c0 50.2-29 98.6-60.2 135.7-15.4 18.3-30.8 33.3-42.4 43.6zm-87.9 79.4l28.5-42.7 36.2 0 28.5 42.7c.9 1.4 1.4 3.1 1.4 4.7 0 4.7-3.8 8.6-8.6 8.6l-78.9 0c-4.7 0-8.6-3.8-8.6-8.6 0-1.7 .5-3.3 1.4-4.7zM192 368s128-96 128-208C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 368 128 368l-27.9 41.8c-2.7 4-4.1 8.8-4.1 13.6 0 13.6 11 24.6 24.6 24.6l78.9 0c13.6 0 24.6-11 24.6-24.6 0-4.8-1.4-9.6-4.1-13.6L192 368zM152 96c4.4 0 8-3.6 8-8s-3.6-8-8-8c-39.8 0-72 32.2-72 72 0 4.4 3.6 8 8 8s8-3.6 8-8c0-30.9 25.1-56 56-56zM294 335.3c37.7 57.5 90 96.7 90 96.7l-27.9 41.8c-2.7 4-4.1 8.8-4.1 13.6 0 13.6 11 24.6 24.6 24.6l78.9 0c13.6 0 24.6-11 24.6-24.6 0-4.8-1.4-9.6-4.1-13.6L448 432s128-96 128-208c0-88.4-71.6-160-160-160-23.1 0-45.1 4.9-64.9 13.7 2.1 4.9 4 9.9 5.8 15 18-8.1 38.1-12.7 59.1-12.7 79.5 0 144 64.5 144 144 0 50.2-29 98.6-60.2 135.7-15.4 18.3-30.8 33.3-42.4 43.6-8.2 7.4-16.7 14.1-25.4 20.7L400 424c-8.7-6.6-17.1-13.3-25.4-20.7-11.6-10.4-27-25.4-42.4-43.6-9.7-11.5-19.2-24.1-27.6-37.5-3.5 4.5-7 8.9-10.6 13.2zM397.9 440l36.2 0 28.5 42.7c.9 1.4 1.4 3.1 1.4 4.7 0 4.7-3.8 8.6-8.6 8.6l-78.9 0c-4.7 0-8.6-3.8-8.6-8.6 0-1.7 .5-3.3 1.4-4.7L397.9 440z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;